import { Heading } from "./heading";
import { Layout } from "./layout";
import { Revenue } from "./revenue";
import { SortMenu } from "./sort-menu";
import { Toolbar } from "./toolbar";
import { TrustSignals } from "./trust-signals";
import { TvlDisplay } from "./tvl-display";
import { useMarketsSortState } from "./use-markets-sort-state";

export const Markets = {
  Heading,
  Layout,
  SortMenu,
  Toolbar,
  TrustSignals,
  Revenue,
  TvlDisplay,
  NoMarkets,
  NoMatchingMarkets,
  useMarketsSortState,
};

export function NoMarkets(): JSX.Element {
  return (
    <div className="flex justify-center text-2xl font-bold text-white">
      No markets are available.
    </div>
  );
}

export function NoMatchingMarkets(): JSX.Element {
  return (
    <div className="flex flex-col items-center justify-center gap-1 rounded-lg bg-shale-800 h-96">
      <h2 className="text-xl font-medium text-white md:text-2xl">
        No results found
      </h2>
      <p className="text-shale-200">
        Try adjusting your search or filter to find what you’re looking for.
      </p>
    </div>
  );
}
